import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(() => {
        try {
            const localData = localStorage.getItem('maxweigh_cart');
            return localData ? JSON.parse(localData) : [];
        } catch (error) {
            console.error("Error loading cart from localStorage:", error);
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem('maxweigh_cart', JSON.stringify(cart));
    }, [cart]);

    const addToCart = (product, model, quantity) => {
        setCart(prevCart => {
            const existingItemIndex = prevCart.findIndex(item =>
                item.id === product.id &&
                ((!item.model && !model) || (item.model && model && item.model.model === model.model))
            );

            if (existingItemIndex > -1) {
                const newCart = [...prevCart];
                newCart[existingItemIndex].quantity += quantity;
                return newCart;
            } else {
                return [...prevCart, { ...product, model, quantity }];
            }
        });
    };

    const removeFromCart = (productId, modelName) => {
        setCart(prevCart => prevCart.filter(item =>
            !(item.id === productId &&
                ((!item.model && !modelName) || (item.model && item.model.model === modelName)))
        ));
    };

    const updateQuantity = (productId, modelName, newQuantity) => {
        if (newQuantity < 1) return;
        setCart(prevCart => prevCart.map(item => {
            if (item.id === productId &&
                ((!item.model && !modelName) || (item.model && item.model.model === modelName))) {
                return { ...item, quantity: newQuantity };
            }
            return item;
        }));
    };

    const clearCart = () => {
        setCart([]);
    };

    const getCartCount = () => {
        return cart.reduce((total, item) => total + item.quantity, 0);
    };

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart, getCartCount }}>
            {children}
        </CartContext.Provider>
    );
};
